module.exports = __webpack_public_path__ + "static/media/RotateLeftButton.b3e21b25.svg";